// Cross-environment UUID v4 generator with fallback when crypto.randomUUID is missing
export function uuid() {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch (e) {}

  // Fallback to RFC4122 version 4 UUID using crypto.getRandomValues when available
  const getRandomBytes = () => {
    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
      return crypto.getRandomValues(new Uint8Array(16));
    }
    // Last resort: Math.random (not cryptographically secure)
    const arr = new Uint8Array(16);
    for (let i = 0; i < 16; i++) arr[i] = Math.floor(Math.random() * 256);
    return arr;
  };

  const bytes = getRandomBytes();
  // Per RFC4122 section 4.4
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant

  const hex = Array.from(bytes).map((b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export default uuid;
